import { css } from "@emotion/react";

export const styles = {
  imag_logo: css`
    align-self: start;

    @media (max-width: 900px) {
      align-self: center;
    }
  `,
  typography__description: css`
    ul,
    ol {
      padding-inline-start: 20px;
    }
    strong {
      font-weight: 600;
    }
  `
};
